import { render, staticRenderFns } from "./HeikenAshi.vue?vue&type=template&id=70ac2ff6&scoped=true"
import script from "./HeikenAshi.vue?vue&type=script&lang=js"
export * from "./HeikenAshi.vue?vue&type=script&lang=js"
import style0 from "./HeikenAshi.vue?vue&type=style&index=0&id=70ac2ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac2ff6",
  null
  
)

export default component.exports